
















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { HeaderList } from '@/components/Table/TableModel';
import Table from '@/components/molecules/Table/Table.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import LineChart from '@/components/organisms/LineChart/LineChart.vue';

import AdminService from '@/api/AdminService';
import AnalyticsService from '@/api/AnalyticsService';

import { Pagination, SortController } from '@/utils/Pagination';
import { IPeriod } from '@/models/period';

@Component({
  components: { Table, TableHeader, TableRow, TableCell, LineChart }
})
export default class BusinessDetailNewCustomersList extends Vue {
  @Prop(String) readonly businessId?: string;
  @Prop() readonly period?: IPeriod;

  service: AdminService = new AdminService();
  analyticsService = new AnalyticsService();
  pagination = new Pagination(this.formatRow);
  sort = new SortController();
  chartData: any = [];
  chartLoading = false;
  query: any = {
    searchableFields: 'c.name',
    search: ''
  };
  headers = [
    new HeaderList(`Customer name`, 'name', '12px 12px 12px 32px'),
    new HeaderList(`Total Spent`, 'totalSpent', '12px', 'right'),
    new HeaderList(
      `Total Rewards`,
      'totalRewards',
      '12px 32px 12px 12px',
      'right'
    )
    // new HeaderList(`Total Purchases`, 'totalMoney', '12px'),
    // new HeaderList(`Total Coin trades/gifts`, 'totalCoins', '12px')
  ];

  handleOpenCustomerDetail(row: Record<string, any>) {
    this.$store.dispatch('modal/SET_SUB_MODAL', {
      component: 'AdminCustomerModal',
      props: {
        data: row
      }
    });
  }

  formatRow(row: any) {
    return {
      ...row,
      name: `${row.name} ${row.lastname}`,
      spent: row.totalSpent,
      rewards: row.totalRewards,
      purchases: row.totalMoney,
      trades: row.totalCoins
    };
  }

  updateSort(field: string) {
    this.sort.update(field);
    this.query = {
      ...this.query,
      sort: this.sort.toString()
    };
  }

  @Watch('query')
  refreshPagination(query: any) {
    this.pagination.refresh(
      `/super-admin/merchant-connect/customers/${this.businessId}`,
      query
    );
  }

  @Watch('period')
  updatePeriod() {
    this.query = {
      ...this.query,
      ...(this.period ? { from: this.period.start } : {}),
      ...(this.period ? { to: this.period.end } : {})
    };
  }

  mounted() {
    this.updatePeriod();
    this.pagination.setPaginationTarget(this.$refs.target as HTMLElement);
  }
}
